import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Card } from '@/components/ui';
import { Icon } from '@/lib/icons';
import { relativeTime } from '@/lib/format';
import { listContacts } from '@/data/client';
import { useSearch } from '@/components/shell/search';
import { ContactFormModal } from '@/components/crm/ContactForm';

export function Contacts() {
  const navigate = useNavigate();
  const { query } = useSearch();
  const [creating, setCreating] = useState(false);
  const { data, isLoading } = useQuery({
    queryKey: ['contacts', { q: query }],
    queryFn: () => listContacts(query),
    placeholderData: (prev) => prev,
  });

  return (
    <div className="crm-list">
      <div className="lead-toolbar">
        <div className="lead-toolbar__right">
          <Button iconLeft={<Icon name="plus" size={16} />} onClick={() => setCreating(true)}>New contact</Button>
        </div>
      </div>
      <Card padding={false}>
        <table className="dash-table lead-table">
          <thead><tr><th>Name</th><th>Company</th><th>Email</th><th>Phone</th><th>Owner</th><th>Updated</th></tr></thead>
          <tbody>
            {data?.map((c) => (
              <tr key={c.id} onClick={() => navigate(`/contacts/${c.id}`)}>
                <td><strong>{c.name ?? c.email ?? c.phone}</strong>{c.title && <span className="crm-cell-sub">{c.title}</span>}</td>
                <td>
                  {c.companyId
                    ? <Link to={`/companies/${c.companyId}`} onClick={(e) => e.stopPropagation()}>{c.companyName}</Link>
                    : <span className="crm-cell-muted">—</span>}
                </td>
                <td>{c.email ?? <span className="crm-cell-muted">—</span>}</td>
                <td>{c.phone ?? <span className="crm-cell-muted">—</span>}</td>
                <td className={c.ownerName ? '' : 'crm-cell-muted'}>{c.ownerName ?? 'Unassigned'}</td>
                <td className="crm-cell-muted">{relativeTime(c.updatedAt)}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {!isLoading && !data?.length && <p className="lead-none">{query ? 'No contacts match your search.' : 'No contacts yet.'}</p>}
      </Card>
      {creating && <ContactFormModal onClose={() => setCreating(false)} />}
    </div>
  );
}
